import React from "react"
import style from "../components/citaatBarsMobile.module.scss"

export default function CitaatBarsMobile() {
  return (
    <div className={style.wrapper}>
      <div className={style.bar1}></div>
      <div className={style.bar2}></div>
      <div className={style.bar3}></div>
      <div className={style.bar4}></div>
    </div>
  )
}
